export default __webpack_public_path__ + "static/6-668ae6453bf7405e12c7e83dda8dd893.svg";